export default __webpack_public_path__ + "static/social-6d2cdde69e2f152e6e9cc7b75d42a1b5.png";